module.exports = __webpack_public_path__ + "static/media/bowtie_logo.6b86dfa8.png";